import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import * as Sentry from "@sentry/angular";

const isProduction = process.env.PRODUCTION === "true";

if (isProduction) {
  enableProdMode();
}

Sentry.init({
  dsn: "https://c7004954938d4a7a5fb3db4189de41c5@o4505269284044800.ingest.us.sentry.io/4507492596318208",
  integrations: [Sentry.browserTracingIntegration()],
  enabled: isProduction,
  tracesSampleRate: 0.1,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
